import { render, staticRenderFns } from "./formMyApprovedTaskHt.vue?vue&type=template&id=a97e0e28&"
import script from "./formMyApprovedTaskHt.vue?vue&type=script&lang=js&"
export * from "./formMyApprovedTaskHt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports